import { State } from './models';

export const documentTypes = (state): State.IState => state.get('documentTypes');
